/**
 * Mixin, добавляющий атрибут inputClass в компоненты.
 *
 * По умолчанию атрибут class направляется только в первый дочерний компонент иерархии.
 * Данный proxy позволяет пробросить атрибут в компонент и затем применить его в нужный компонент.
 *
 * Актуально для XValidation*-компонентов, т.к. там первый дочерний элемент - ValidationProvider
 */
export const inputClass = {
  props: {
    inputClass: {
      required: false
    }
  },
}